var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fdfeff",
    floodOpacity: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_261",
    "data-name": "Sfumatura senza nome 261",
    x1: 316.27,
    y1: 621.19,
    x2: 549.55,
    y2: 622.41,
    gradientTransform: "translate(933.81 -141.8) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b398d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b4a99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_470",
    "data-name": "Sfumatura senza nome 470",
    x1: 199.57,
    y1: 504.98,
    x2: 353.85,
    y2: 738,
    gradientTransform: "translate(933.81 -141.8) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#438ccb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4d97cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#60add3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6dbdd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#75c6d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78c9da"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_472",
    "data-name": "Sfumatura senza nome 472",
    x1: 160.26,
    y1: 723.74,
    x2: 269.51,
    y2: 528.25,
    gradientTransform: "translate(933.81 -141.8) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e3e90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7c4593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#97519a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#a8599e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ae5ca0"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#drop-shadow-1)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "479.91 328.41 479.91 134.91 415.07 172.34 415.07 290.98 312.32 350.3 209.58 290.98 209.58 172.34 144.74 134.91 144.74 328.41 312.32 425.17 479.91 328.41",
    style: {
      fill: "url(#Sfumatura_senza_nome_261)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.91 134.91 415.07 97.47 312.32 156.79 209.58 97.47 144.74 134.91 312.32 231.66 479.91 134.91",
    style: {
      fill: "url(#Sfumatura_senza_nome_470)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.32 113.04 377.17 75.6 312.32 38.17 247.48 75.6 312.32 113.04",
    style: {
      fill: "url(#Sfumatura_senza_nome_472)",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(32.08 539.75)",
    style: {
      fontSize: "83.04px"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#ae5ca0",
      fontFamily: "Montserrat-Bold, Montserrat",
      fontWeight: 700
    }
  }, "DATA"), /*#__PURE__*/React.createElement("tspan", {
    x: 240.47,
    y: 0,
    style: {
      fill: "#4b398d",
      fontFamily: "Montserrat-Light, Montserrat",
      fontWeight: 300
    }
  }, "Minder")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.1816d22f6fb7ddb4ad83abc34b88c57b.svg";
export { ForwardRef as ReactComponent };